import './assets/scss/main.scss';

import component from './App.vue';

export { LOADED_EVENT } from './constants';

export default (() => {
  component.install = Vue => {
    Vue.component('AuthorizationFlow', component);
  };

  return component;
})();
